import { getUltheraEvidenceReviews } from '../_data/evidence'

/**
 * 울쎄라 통증·마취 페이지가 사용하는 검수 완료 정적 데이터.
 *
 * 원본: 울쎄라_100자이상_전체_260825.csv
 * 화면 시안: 울쎄라_통증마취페이지_실데이터_260831.html
 * 화면 표시 집계일: 2026-08-25
 * 병원명·의료진·작성자 정보는 소비자 화면에 전달하지 않는다.
 */
export const ultheraPainCorpus = {
  validReviewCount: 13_478,
  duplicateSentenceCount: 149,
  painCandidateCount: 2_129,
  sourceCount: 4,
  reviewPeriod: "2019.01.13~2026.08.24",
  countedAt: "2026.08.25",
} as const

export const ultheraPainTableOfContents = [
  { id: "section-01", title: "참을 만했다는 사람도, 겨우 버텼다는 사람도 있어요" },
  { id: "section-02", title: "턱뼈 가까운 곳에서 유독 찌릿했대요" },
  { id: "section-03", title: "연고만 한 사람도, 주사마취를 더한 사람도 있었어요" },
  { id: "section-04", title: "자고 끝낸 사람도, 비수면을 고른 사람도 있었어요" },
  { id: "section-05", title: "프라임도 사람마다, 턱에서는 이를 꽉 물었대요" },
  { id: "section-06", title: "끝나도 얼얼함이 며칠 남은 사람도 있었어요" },
] as const

export const ultheraPainEvidenceReviews = getUltheraEvidenceReviews('pain')

export const ultheraPainEvidenceCount = ultheraPainEvidenceReviews.length
